import { PortfolioRenewalStats } from "../api/models";

export interface Props {
    stats?: PortfolioRenewalStats
    statsMtd?: PortfolioRenewalStats
    hideAutoRenew?: boolean;
}

function StatRow({ label, today, mtd }: { label: string; today: number; mtd: number }) {
    return (
        <div className="flex items-center justify-between py-1.5 border-b border-border last:border-b-0 gap-2">
            <span className="text-sm text-text-2 truncate shrink">{label}</span>
            <div className="flex items-center gap-2 font-mono text-sm shrink-0">
                <span className="text-text font-medium tabular-nums">{today.toLocaleString()}</span>
                <span className="text-text-3 tabular-nums">{mtd.toLocaleString()}</span>
            </div>
        </div>
    );
}

const RenewalMethodStats = (props: Props) => {
    if (!props.stats || !props.statsMtd) {
        return <div className="text-base text-text-3 py-4 text-center">Unavailable</div>;
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-1 px-0.5">
                <div />
                <div className="flex gap-3 text-2xs uppercase tracking-wider text-text-3 font-semibold">
                    <span>Today</span>
                    <span>MTD</span>
                </div>
            </div>
            <StatRow label="Support Email" today={props.stats.methodSupportEmail} mtd={props.statsMtd.methodSupportEmail} />
            <StatRow label="Legacy" today={props.stats.methodLegacy} mtd={props.statsMtd.methodLegacy} />
            {!props.hideAutoRenew && (
                <StatRow label="Auto Renew" today={props.stats.methodAutoRenew} mtd={props.statsMtd.methodAutoRenew} />
            )}
            <StatRow label="Other" today={props.stats.methodOther} mtd={props.statsMtd.methodOther} />
        </div>
    );
};

export default RenewalMethodStats;
